import { styled } from '@mui/material'

export const Root = styled('div')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: 0;
  padding: 48px 16px;
  width: 100%;
`

export const Text = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-size: 27px;
  font-weight: 400;
  line-height: 31px;
  margin: 72px 0 32px 0;
  max-width: 700px;
  text-align: center;
  ${props => props.theme.breakpoints.down('md')} {
    font-size: 24px;
    line-height: 27px;
    margin: 48px 0 32px 0;
  }
`

export const Image404 = styled('img')`
  max-width: 378px;
  width: 90%;
  ${props => props.theme.breakpoints.down('md')} {
    max-width: 250px;
  }
`
